import Vue from 'vue';
import * as _ from 'lodash';
import OfferService from '@/app/offer/offer.service';
import download from 'downloadjs';
import {ampelEnum, orderStatusOptionsEnum} from '@/shared/enum';
import moment from 'moment';

const getDefaultItem = () => ({
    _id: null,
    receivedVia: null,
    receivedDate: null,
    receivedFrom: null,
    orderStatus: orderStatusOptionsEnum.IN_PROGRESS,
    product: null,
    potential: 0,
    country: null,
    prospect: null,
    prospectEmail: null,
    prospectTelNr: null,
    customerNr: null,
    vkiUser: null,
    vkaUser: null,
    deliveryDate: null,
    status: null,
    deleteFilesDate: null,
    team: null,
    ampel: ampelEnum.BLACK,
    notes: [],
    files: [],
    angebot: {
        offerNr: null,
        offerDate: null,
        offerSum: null,
        expiryDate: null,
        followUp: [],
        notes: [],
    },
});

const getDefaultLastSearch = () => ({
    type: null,
    value: null,
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
    currentPage: 1,
    totalPages: 1,
    lastSearch: getDefaultLastSearch(),
});

const offer = {
    namespaced: true,
    state: Object.assign({}, getDefaultState()),
    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        updateCurrentPage(state, data) {
            Vue.set(state, 'currentPage', data);
        },
        updateTotalPages(state, data) {
            Vue.set(state, 'totalPages', data);
        },
        updateLastSearch(state, data) {
            Vue.set(state, 'lastSearch', data);
        },
        clear(state) {
            Vue.set(state, 'item', JSON.parse(JSON.stringify(getDefaultState().item)));
            Vue.set(state, 'list', JSON.parse(JSON.stringify(getDefaultState().list)));
        },
        clearLastSearch(state) {
            Vue.set(state, 'lastSearch', JSON.parse(JSON.stringify(getDefaultState().lastSearch)));
        },
    },
    actions: {
        clear({ commit }) {
            commit('clear');
        },
        clearLastSearch({ commit }) {
            commit('clearLastSearch');
        },
        updateLastSearch(context, lastSearch) {
            context.commit('updateLastSearch', lastSearch);
        },
        async create(context, client_data) {
            const { data } = await OfferService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await OfferService.update(client_data.offer._id, client_data);
            context.commit('update', data);
            return data;
        },
        async query(context, params) {
            const { data } = await OfferService.query(params);
            let currPage = params && params.params && params.params.page ? params.params.page : 0;
            context.commit('updateCurrentPage', currPage);
            let totalPages = data.pages;
            context.commit('updateTotalPages', _.ceil(totalPages));
            context.commit('updateList', data);
            return data;
        },
        async get(context, id) {
            const { data } = await OfferService.get(id);
            context.commit('update', data);
            return data;
        },
        async updateOffer(context, client_data) {
            const offer = client_data;
            context.commit('update', offer);
            return offer;
        },
        async getFile(context, client_data) {
            const data = await OfferService.getFile(client_data.blobId);
            let serverFileName = '';
            if (data.headers['content-disposition']) {
                if (data.headers['content-disposition'].split('filename=')[1]) {
                    serverFileName = data.headers['content-disposition'].split('filename=')[1];
                }
            }
            let contentType = 'application/pdf';
            if (data.headers['content-type']) {
                contentType = data.headers['content-type'];
            }
            let fileName = 'Angebotsanhang.txt';
            if (serverFileName !== '' || serverFileName != null) {
                fileName = serverFileName;
            }
            download(new Blob([data.data]), fileName, contentType);
        },
        async getUpdatedAt(context, id) {
            const { data } = await OfferService.getUpdatedAt(id);
            return data;
        },
        async exportExcel() {
            const data = await OfferService.exportExcel();
            let today = moment().format('DD-MM-YYYY_HHmm');
            let filename = 'Angebote_' + today + '.xlsx';
            download(
                new Blob([data.data]),
                filename,
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            );
        },
        async importCsv(context, { file }) {
            await OfferService.importCsv(file);
        },
        async fileUpload(context, { file, tenant, type }) {
            const { data } = await OfferService.fileUpload(file, { tenant, type });
            // context.commit('update', data);
            return data;
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
        currentPage(state) {
            return state.currentPage;
        },
        totalPages(state) {
            return state.totalPages;
        },
        lastSearch(state) {
            return state.lastSearch;
        },
    },
};
export { getDefaultItem };
export default offer;
